import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function SlideBanner(props) {
  let [naviCount, setNaviCount] = useState(1);
  const [autoPlayButton, setAutoPlayButton] = useState(true);
  const [swiperRef, setSwiperRef] = useState(null);
  let [maxPageCount, setMaxPageCount] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const paginationDisplayState = maxPageCount == 1 ? 'none' : 'flex';

  const swiperAutoButtonHandler = () => {
    if (autoPlayButton) {
      swiperStop();
    } else {
      swiperStart();
    }
  };

  const naviCountHandler = (count) => {
    if (naviCount === maxPageCount) {
      setNaviCount(1);
    } else {
      setNaviCount(naviCount + count);
    }
    swiperStop();
  };

  useEffect(() => {
    setMaxPageCount(Math.ceil(props.data.length));
  }, [naviCountHandler]);

  const swiperStart = () => {
    setAutoPlayButton(true);
    swiperRef.autoplay.start();
  };

  const swiperStop = () => {
    setAutoPlayButton(false);
    swiperRef.autoplay.stop();
  };

  const handleSlideChange = () => {
    if (swiperRef) {
      setActiveIndex(swiperRef.realIndex); // 현재 슬라이드의 실제 인덱스를 가져옵니다.
    }
  };

  return (
    <>
      <div className="swiperBannerWrap">
        <button
          type="button"
          aria-label="다음 콘텐츠 보기"
          className="btnTypeList-Next swiper-button-next"
        >
          <span className="iconSvg_arrow">
            <i className="hide">다음</i>
          </span>
          <span className="pagingNumber_w">
            <strong className="pagingNumber-now">
              {activeIndex === swiperRef?.slides.length - 1
                ? 1
                : activeIndex + 2}
            </strong>
            /{swiperRef?.slides.length}
          </span>
        </button>
        <Swiper
          onSwiper={setSwiperRef}
          slidesPerView={1}
          mousewheel={false}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ el: `.swiperBannerWrap .swiper-pagination` }}
          navigation={{
            nextEl: `.swiperBannerWrap .swiper-button-next`,
            prevEl: `.swiperBannerWrap .swiper-button-prev`,
          }}
          onSlideChange={handleSlideChange}
          modules={[Autoplay, Pagination, Navigation]}
          className="listModuleSlider"
          wrapperClass="SliderContent"
        >
          {props.data.map((item, index) => {
            return (
              <SwiperSlide key={`swiper-slide-${index}`}>
                <div className="listModuleItem swiper-slide">
                  <a
                    href={item.link_url}
                    className="swiperBnrLink"
                    target={item.link_type}
                    style={{ backgroundColor: item.background_color }}
                  >
                    <img src={item.image_url} alt={item.image_text} />
                  </a>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          className="swiper-pagination_w"
          style={{ display: paginationDisplayState }}
        >
          <div className="swiper-pagination"></div>
          <div
            className={`swiperBtnAutoPlay-control ${
              autoPlayButton ? 'statePlay' : ''
            }`}
          >
            <button
              type="button"
              className="swiperBtn-autoPlay"
              onClick={swiperAutoButtonHandler}
            >
              <i className="hide">재생</i>
            </button>
            <button
              type="button"
              className="swiperBtn-pause"
              onClick={swiperAutoButtonHandler}
            >
              <i className="hide">일시정지</i>
            </button>
          </div>
        </div>
        <button
          type="button"
          aria-label="이전 콘텐츠 보기"
          className="btnTypeList-Prev swiper-button-prev"
        >
          <span className="iconSvg_arrow">
            <i className="hide">이전</i>
          </span>
          <span className="pagingNumber_w">
            <strong className="pagingNumber-now">
              {activeIndex === 0 ? swiperRef?.slides.length : activeIndex}
            </strong>
            /{swiperRef?.slides.length}
          </span>
        </button>
      </div>
    </>
  );
}
